<template>
  <div class="home-box">
    <Breadcrumbs :title="pageTitle"></Breadcrumbs>
    <v-row align="center">
      <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular
          color="#FFB300"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

      <div class="col-md-12 home-tabs-body">
        <ExpenseTable></ExpenseTable>
      </div>
    </v-row>
  </div>
</template>

<script>
import ExpenseTable from "@/components/expenses/ExpenseTable";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "ExpenseList",
  components: {
    Breadcrumbs,
    ExpenseTable,
  },

  data: function() {
    return {
      role: localStorage.getItem("role") || null,
      errors: null,
      loading: false,
      pageTitle: "Expenses",
    };
  },
  computed: {
    ...mapGetters({
      vuexloading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
  },
};
</script>
